import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
} from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { environment } from "src/environments/environment";

const isSentryEnabled = environment.sentry.enabled;
const sentryProviders = isSentryEnabled
  ? [
      {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler(),
      },
      {
        provide: Sentry.TraceService,
        deps: [Router],
      },
      {
        provide: APP_INITIALIZER,
        useFactory: () => () => {},
        deps: [Sentry.TraceService],
        multi: true,
      },
    ]
  : [];

export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(withInterceptorsFromDi()), ...sentryProviders],
};
